<template>
  <div class="altel-banner">
    <div class="container">
    <div class="altel-banner__inner">
      <div class="altel-banner__left altel-banner__item">
        <div class="altel-banner__text">
          <h1 class="altel-banner__title">
            {{ $t('banner.title')}}
          </h1>
          <div class="altel-banner__description">
            {{ $t('banner.subtitle')}}
          </div>
        </div>
      </div>
      <div class="altel-banner__right altel-banner__item">
        <img
          class="altel-banner__img"
          src="@/assets/img/altelvisual.png"
          alt="banner"
        >
      </div>
    </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.altel-banner{
  background: #F6F7F7;
    &__inner{
        height: 240px;
        display: flex;
    }
    &__item{
        flex: 1;
        display: flex;
        align-items: center;
        
    }
    &__title{
        font-style: normal;
        font-weight: 500;
        font-size: 40px;
        line-height: 48px;
        color: $primary-black;
        margin-bottom: 16px;
        font-weight: 700;
        text-transform: uppercase;
        width: 80%;
    }
    &__description{
        font-style: normal;
        font-size: 17px;
        color: $primary-gray;
        line-height: 25px;
        font-weight: 500;
        letter-spacing: -0.03em;
    }
    &__text{
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
    }
    &__img{
      display: block;
      max-height: 240px;
      height: 100%;
    }
}
@media (min-width: 320px) and (max-width: 641px) {
.altel-banner{
    &__inner{
        flex-direction: column;
        height: 200px;
    }
    &__title{
        font-size: 24px;
        line-height: 34px;
        width: 100%;
        margin: 0 0 8px 0;
    }
    &__description{
        font-size: 16px;
        line-height: 19px;
    }
    &__right{
      display: none;
    }
    &__img{
        display: none;
    }

}
}
@media (min-width: 642px) and (max-width: 768px) {
  .altel-banner{
    &__title{
        font-size: 28px;
        line-height: 38px;
        width: 100%;
    }
    &__description{
      font-size: 18px ;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
.altel-banner{
    &__title{
        font-size: 30px;
        line-height: 42px;
        width: 80%;
    }
    &__img{
        max-width: 400px;
        width: 100%; 
        margin-right: 20px;
    }
}
}
</style>
